import { render, staticRenderFns } from "./signBack.vue?vue&type=template&id=4f5dfcc1&scoped=true&"
import script from "./signBack.vue?vue&type=script&lang=js&"
export * from "./signBack.vue?vue&type=script&lang=js&"
import style0 from "./signBack.vue?vue&type=style&index=0&id=4f5dfcc1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5dfcc1",
  null
  
)

export default component.exports